import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Navigate } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { AuthPaperBox } from 'src/components/auth';
import { Button } from 'src/components/common';
import { StripeCustomerPaymentMethodsList } from 'src/components/stripe/StripeCustomerPaymentMethodsList';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';
import { useStripeCustomerPaymentMethods } from 'src/hooks/stripe';
import { useCurrentUserVerifierStaff } from 'src/hooks/verifierStaff';
import { type SxProp } from 'src/types/mui';

export const SetupPaymentMethodsPageContent: React.FC = () => {
  const { verifierStaff } = useCurrentUserVerifierStaff();

  const { openModal } = useModal(ModalId.StripeAddPaymentMethodModal);

  const { paymentMethods, loadingPaymentMethods } = useStripeCustomerPaymentMethods(
    verifierStaff?.stripeCustomerId,
  );

  const handleAddButtonClick = React.useCallback(() => {
    openModal(ModalId.StripeAddPaymentMethodModal);
  }, [openModal]);

  if (loadingPaymentMethods) {
    return <CircularProgress />;
  }

  if (paymentMethods.length > 0) {
    return <Navigate to={appRoutes.root} />;
  }

  return (
    <AuthPaperBox sx={containerStyles}>
      <Typography variant="body2" fontSize="24px">
        Payment method
      </Typography>

      <Typography variant="body2" fontSize="16px" mt={1}>
        Add payment method to your account
      </Typography>

      <Box>
        <StripeCustomerPaymentMethodsList stripeCustomerId={verifierStaff?.stripeCustomerId} />

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button
            startIcon={<AddIcon />}
            color="primary"
            variant={paymentMethods.length ? 'outlined' : 'contained'}
            sx={{ mr: 2 }}
            onClick={handleAddButtonClick}
          >
            Add
          </Button>
        </Box>
      </Box>
    </AuthPaperBox>
  );
};

const containerStyles: SxProp = {
  maxWidth: 640,
};
